
import React from 'react';

const DocumentsIcon = (props) => {

  let { 
    height, 
    width, 
    iconColor,
  } = props;
    
  return (
    <svg 
      width={width ? width : '21px'} 
      height={height ? height : '19px'} 
      viewBox="0 0 27 24" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg">
      <title>Documents</title>
      <path fill={iconColor} fillRule="nonzero" 
        d="M13.889 24h-1.701c-1.085 0-1.993-.762-2.181-1.774l-9.62-2.609a.523.523 0 0 
          1-.387-.5V3.652c0-.156.063-.302.188-.396a.508.508 0 0 1 .417-.115l2.525.407V.522C3.13.23 
          3.36 0 3.652 0c4.988 0 8.045 1.7 9.391 3.391C14.39 1.701 17.447 0 22.435 0c.292 0 
          .522.23.522.522v3.026l2.525-.407c.146-.021.302.02.417.115.115.104.188.24.188.396v15.454c0 
          .24-.157.438-.386.501l-9.621 2.609A2.238 2.238 0 0 1 13.889 24zM1.033 18.71l9.59 
          2.598c.23.062.386.271.386.5 0 .616.542 1.149 1.179 1.149h1.7c.637 0 1.18-.522 1.18-1.148 
          0-.24.156-.439.386-.501l9.59-2.598V4.268l-2.087.334v12.407c0 .292-.23.521-.522.521-4.915 
          0-6.658 1.263-8.432 2.912-.594.553-1.325.553-1.92 0-1.773-1.649-3.516-2.912-8.43-2.912a.517.517 
          0 0 1-.523-.521V4.602l-2.087-.334V18.71h-.01zM13.555 4.466V19.44c1.742-1.576 3.694-2.849 
          8.348-2.943V1.054c-4.78.115-7.45 1.868-8.348 3.412zM4.163 16.497c4.654.084 6.606 1.367 
          8.348 2.943V4.466c-.897-1.544-3.568-3.297-8.348-3.412v15.443z"/>
    </svg>
  );
};

export default DocumentsIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/DocumentsIcon/index.js